
import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import Features from '@/components/Features';
import HowItWorks from '@/components/HowItWorks';
import CallToAction from '@/components/CallToAction';
import Footer from '@/components/Footer';

const Index = () => {
  // Update the document title for SEO
  useEffect(() => {
    document.title = "PromptCraft | Perfect AI Prompts for Development";
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Fixed background elements */}
      <div className="fixed inset-0 z-[-1] overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-background to-background/90"></div>
        <div className="absolute top-0 -left-40 w-96 h-96 bg-purple-600/10 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 -right-20 w-96 h-96 bg-indigo-600/10 rounded-full filter blur-3xl"></div>
        <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-fuchsia-600/5 rounded-full filter blur-3xl"></div>
      </div>
      
      <Navbar />
      
      <main className="flex-grow">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Hero />
          <Features />
          <HowItWorks />
          <CallToAction />
        </motion.div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Index;
